import React from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  explanationText: {
    fontSize: 8,
    color: '#666666',
    lineHeight: 1.4,
    marginBottom: 15,
  },
  chartsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  chartContainer: {
    width: '48%',
    backgroundColor: '#f9f9f9',
    border: '1 solid #e0e0e0',
    borderRadius: 8,
    padding: 8,
    marginBottom: 12,
    marginRight: '4%',
  },
  chartContainerRight: {
    marginRight: 0,
  },
  chartRow: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  phaseTitle: {
    fontSize: 8,
    fontWeight: 600,
    marginBottom: 6,
    color: '#333333',
    textAlign: 'center',
  },
  chartImage: {
    width: '100%',
    height: 90,
    objectFit: 'contain',
  },
  legend: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 15,
    justifyContent: 'center',
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 10,
    marginBottom: 5,
  },
  legendColor: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 4,
  },
  legendText: {
    fontSize: 7,
    color: '#666666',
  },
});

// Category colors
const categoryColors = {
  skills: '#4CAF50',      // Green
  knowledge: '#2196F3',   // Blue  
  mindset: '#FF9800',     // Orange
  instruments: '#9C27B0', // Purple
};

const PHASES = ['Empathize', 'Define', 'Ideate', 'Prototype', 'Test', 'Communicate'];

const Distribution = ({ chartImages }) => {
  console.log("Distribution PDF component received chartImages:", chartImages);
  console.log("Number of chart images:", chartImages ? Object.keys(chartImages).length : 0);
  
  if (!chartImages || Object.keys(chartImages).length === 0) {
    return (
      <View style={styles.container}>
        <Text style={styles.explanationText}>
          No chart data available. Chart images: {chartImages ? JSON.stringify(Object.keys(chartImages)) : 'null'}
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Text style={styles.explanationText}>
        Shows the number of competencies in each category for each design thinking phase. Each chart represents one phase, with vertical bars showing the count of competencies in each category (Skills, Knowledge, Mindset, Instruments). Charts include proper axes with Y-axis showing competency counts and X-axis showing categories.
      </Text>
      
      <View style={styles.chartsGrid}>
        {PHASES.filter(phase => chartImages[phase]).map((phase, index) => {
          const isEven = index % 2 === 0;
          const isLastInRow = index % 2 === 1 || index === PHASES.filter(p => chartImages[p]).length - 1;
          
          return (
            <View key={phase} style={[
              styles.chartContainer,
              isLastInRow && styles.chartContainerRight
            ]}>
              <Text style={styles.phaseTitle}>{phase}</Text>
              <Image 
                src={chartImages[phase]} 
                style={styles.chartImage}
              />
            </View>
          );
        })}
      </View>

      <View style={styles.legend}>
        {Object.entries(categoryColors).map(([category, color]) => (
          <View key={category} style={styles.legendItem}>
            <View style={[
              styles.legendColor,
              { backgroundColor: color }
            ]} />
            <Text style={styles.legendText}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default Distribution;